import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["IntlProvider"] */ "/app/src/app/website/[domain]/[[...slugs]]/intl-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BodyCustomCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Error"] */ "/app/src/components/Error/Error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/HeadCustomCode.tsx");
